import { wait } from ".";
import { ObservableQuery } from "@apollo/client";

export const getDelayRefetchQueryFn =
  (ms: number) => async (observableQuery: ObservableQuery<unknown>) => {
    await wait(ms);
    observableQuery.refetch();
  };
